export const SAVE = 'stepAppsureBankDetails.SAVE';
export const VALUE_CHANGED = 'stepAppsureBankDetails.VALUE_CHANGED';
export const LOAD = 'stepAppsureBankDetails.VALUE_LOAD';
export const NEXT = 'stepAppsureBankDetails.NEXT';
export const RESET = 'stepAppsureBankDetails.RESET';
export const RESET_REGISTER_GST_STATE = 'stepAppsureBankDetails.RESET_REGISTER_GST_STATE';
export const CLOSE_BSB_NOTICE = 'stepAppsureBankDetails.CLOSE_BSB_NOTICE';
export const RESET_TUGO_BANK_FIELDS = 'stepAppsureBankDetails.RESET_TUGO_BANK_FIELDS';
export const RESET_ADDRESS = 'stepAppsureBankDetails.RESET_ADDRESS';



// WEBPACK FOOTER //
// ./app/containers/FastCover/Appsure.StepBankDetails/constants.js